export default __webpack_public_path__ + "static/media/ajay.c119482c.jpg";